/** @jsx jsx */
import type { Interpolation, Theme } from '@emotion/react';
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import Imgix from 'js/components/Imgix';

import { Grid, Typography2 } from '@coursera/cds-core';

import { CAREER_CARD_OVERRIDE_PARTNER_LOGOS } from 'bundles/unified-career-academy/constants';
import type { Asset } from 'bundles/unified-career-academy/types';

import _t from 'i18n!nls/career-academy';

type Props = {
  credentials?:
    | ({
        slug?: string | null;
        programName?: string | null;
        partnerInformationCollection?: {
          items?: ({ partnerLogo?: Asset; partnerSlug?: string | null } | null)[] | null;
        } | null;
      } | null)[]
    | null;
};

const style: Record<string, Interpolation<Theme>> = {
  partnerLogo: () => css`
    display: inline-flex;
    border: 1px solid var(--cds-color-grey-200);
    border-radius: 4px;
    height: 40px;
    width: 40px;
    padding: var(--cds-spacing-50);
    margin-right: var(--cds-spacing-150);
    margin-top: var(--cds-spacing-100);
    align-items: center;

    img {
      width: 100%;
    }
  `,
  partnerInfo: css`
    align-items: center;
  `,
};

const CareerCardCredentialsNoLink: React.FC<Props> = ({ credentials }) => {
  return (
    <Grid container direction="column">
      <Grid item>
        <Typography2 component="h3" variant="subtitleMedium">
          {_t('Credentials from leading partners')}
        </Typography2>
      </Grid>
      <Grid item container wrap="wrap">
        {credentials?.map((cred) => {
          const logo = cred?.partnerInformationCollection?.items?.[0]?.partnerLogo;
          const partnerSlug = cred?.partnerInformationCollection?.items?.[0]?.partnerSlug;
          const logoUrl =
            partnerSlug && CAREER_CARD_OVERRIDE_PARTNER_LOGOS[partnerSlug]
              ? CAREER_CARD_OVERRIDE_PARTNER_LOGOS[partnerSlug]
              : logo?.url;

          if (!logoUrl) {
            return null;
          } else {
            return (
              <div css={style.partnerLogo} key={cred?.slug}>
                <Imgix src={logoUrl} alt={logo?.description || ''} />
              </div>
            );
          }
        })}
      </Grid>
    </Grid>
  );
};

export default CareerCardCredentialsNoLink;
